// components/ErrorBoundary.jsx
import React from 'react';
import { MdError } from "react-icons/md";


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error for debugging or send to monitoring service
    console.error("Caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Show detailed error only in development
      if (process.env.NODE_ENV === 'development') {
        return (
          <div style={{ padding: '2rem' }}>
            <h2>Something went wrong.</h2>
            <p>{this.state.error?.toString()}</p>
          </div>
        );
      }

      // In production, show a friendly 404 or error page
      return (
        <div style={{ padding: '2rem' }}>
          <ErrorPage />
        </div>
      );
    }

    return this.props.children;
  }
}


const ErrorPage = () => {

  return (

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "20px",
        minHeight: "60vh",
      }}
    >

    <MdError className='breathing-error' />
      <h1 style={{ maxWidth: "600px", fontSize: "1.25rem", marginTop: "16px" }}>
        We've run into an issue. Try reloading the page. If the issue persists,{" "}
        <a
          href="mailto:customerservice@luse.co.zm"
          style={{ color: "#039606", textDecoration: "none", fontWeight: "bold" }}
        >
          click here to contact us
        </a>
        .
      </h1>
    </div>

  )
}

export { ErrorBoundary, ErrorPage };
